/**
 * Copyright (c) 2021 TechDivision GmbH
 * All rights reserved
 */
import LocalStorageObjectHelper from "./LocalStorageObjectHelper"

/**
 * @class ProductComparison
 * handles the events for the product comparison
 */
class ProductComparison {

    constructor(productComparisonWrapper) {

        this.productCompareSelectComponents = productComparisonWrapper.querySelectorAll(
            '.js-product-comparison--select'
        )

        /**
         * The identifier for the product storage
         *
         * @type {LocalStorageObjectHelper}
         */
        this.ProductComparisonDataHelper = new LocalStorageObjectHelper('comparisonProducts')


        this.bindEvents()
    }


    /**
     * Bind all needed events
     *
     * @method bindEvents
     */
    bindEvents() {
        this.productCompareSelectComponents.forEach( (element, index) => {
            element.addEventListener('change', (event) => this.productSelect(event))
        })
    }

    /**
     * Execute event logic on product selection
     *
     * @method productSelect
     */
    productSelect(event) {
        event.preventDefault()
        let targetUrl = location.protocol + '//' + location.host + location.pathname
        let counter = 1
        let glue = '?'

        this.productCompareSelectComponents.forEach((element) => {
            if (element.value.length) {
                glue = counter > 1 ? '&' : glue
                targetUrl = targetUrl + glue + 'prod' + counter + '=' + element.value
                counter++
            }
        })
        window.location.href = targetUrl
    }
}

function initProductComparison() {
    const productComparisonWrapper = document.querySelector('.js-product-comparison')
    if (productComparisonWrapper) {
        new ProductComparison(productComparisonWrapper)
    }
}

// If the script is initialized after the document is already loaded, initialize modules instantly
if (document.readyState !== 'loading') {
    initProductComparison()
} else {
    // else add an event listener for when the document is fully loaded
    document.addEventListener('DOMContentLoaded', initProductComparison)
}

